// Generated by scripts/update-seeq-icons.js from src/svg/seeq/series.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSeries = {
  prefix: 'fak',
  iconName: 'series' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e90c',
    'M988.2 599c-10.2-15.4-30.7-30.7-51.2-30.7v0c-20.5 0-41 10.2-51.2 25.6l-117.8 194.6-143.4-512c-5.1-25.6-25.6-41-51.2-41s-46.1 10.2-56.3 35.9l-122.9 286.7-143.3-496.7c-5.1-25.6-30.7-41-56.3-40.9s-46.1 15.4-56.4 40.9l-143.3 435.2c-5.1 15.4-5.1 30.7-5.1 46.1v117.8c0 20.5 20.5 35.8 40.9 30.7v0c15.4-5.1 25.6-20.5 35.9-35.8l122.8-378.9 138.3 471c5.1 25.6 25.6 41 51.2 41s46.1-10.2 56.3-35.9l122.9-281.6 133.1 486.4c5.1 20.5 25.6 41 46.1 46.1 5.1 0 5.1 0 10.2 0 20.5 0 41-10.2 51.2-25.6l133.1-230.4 46.1 81.9c10.2 15.4 35.8 10.2 35.9-10.2v-133.1c0-15.4-5.1-25.6-10.3-41l-15.3-46.1z',
  ],
} satisfies IconDefinition;
